// @flow
import { filterList } from '../utils/sort/sort'
import { editShowingDataset } from './dataset/dataset'
import * as actionTypes from '../actionTypes/searchTypes'

const {
  SELECT_VALUE,
  DESELECT_VALUE,
  CHANGE_SEARCH_VALUE,
  FILTER_SUGGESTIONS
} = actionTypes

export function selectValue(selected: Object): Object {
  return {
    type: SELECT_VALUE,
    selected
  }
}

export function deselectValue(): Object {
  return dispatch => {
    dispatch({
      type: DESELECT_VALUE,
      selected: null
    })
    dispatch(editShowingDataset())
  }
}

export function changeSearchValue(searchValue: string): Object {
  return {
    type: CHANGE_SEARCH_VALUE,
    searchValue
  }
}

export function filterSuggestions(
  searchValue: string,
  list: Array<Object>
): Object {
  if (!searchValue) {
    return {
      type: FILTER_SUGGESTIONS,
      list: []
    }
  }
  const suggestions = filterList(searchValue, list)

  // .sort((a, b) =>
  //   b.name.localeCompare(a.name)
  // )

  return {
    type: FILTER_SUGGESTIONS,
    list: suggestions
  }
}

export function handleChangeSearchValue(searchValue: string): Function {
  return (dispatch: Function, getState: Function) => {
    const { rootData } = getState().dataset
    dispatch(changeSearchValue(searchValue))
    dispatch(filterSuggestions(searchValue, rootData))
  }
}



// WEBPACK FOOTER //
// ./src/shared/actions/search.js